var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4262.000000, -766.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Bill",
    transform: "translate(4262.000000, 766.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,18 L28,18 L28,16 L18,16 L18,18 Z M18,22 L28,22 L28,20 L18,20 L18,22 Z M3,18 L13,18 L13,16 L3,16 L3,18 Z M3,22 L13,22 L13,20 L3,20 L3,22 Z M3,12 L6,12 L6,9 L3,9 L3,12 Z M18,12 L21,12 L21,9 L18,9 L18,12 Z M0,6 L0,26 L27,26 C30,26 32,24 32,21 L32,6 L0,6 Z",
    id: 100
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsBill);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-bill.ff23a3fd.svg";
export { ForwardRef as ReactComponent };